export default __webpack_public_path__ + "static/media/th.cad799d8.svg";